import _ from 'lodash';
import { CALL_API } from '../../../middlewares/api';

import {
    REQUEST_PASSWORD_RESET_INIT_USERNAME,
    SUCCESS_PASSWORD_RESET_INIT_USERNAME,
    FAILURE_PASSWORD_RESET_INIT_USERNAME,
    REQUEST_PASSWORD_RESET_INIT_EMAIL,
    SUCCESS_PASSWORD_RESET_INIT_EMAIL,
    FAILURE_PASSWORD_RESET_INIT_EMAIL,
    REQUEST_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_COMMIT,
    FAILURE_PASSWORD_RESET_COMMIT
} from './constants';
import { HTTP_METHOD_POST, HTTP_METHOD_PUT } from '../../../constants/httpMethod';

export function passwordResetInitUsername(form) {
    return {
        [CALL_API]: {
            endpoint: '/auth/password-reset',
            method: HTTP_METHOD_POST,
            body: form,
            types: [
                REQUEST_PASSWORD_RESET_INIT_USERNAME,
                SUCCESS_PASSWORD_RESET_INIT_USERNAME,
                FAILURE_PASSWORD_RESET_INIT_USERNAME
            ],
            authenticated: false
        }
    };
}

export function passwordResetInitEmail(form) {
    return {
        [CALL_API]: {
            endpoint: '/auth/password-reset',
            method: HTTP_METHOD_POST,
            body: form,
            types: [
                REQUEST_PASSWORD_RESET_INIT_EMAIL,
                SUCCESS_PASSWORD_RESET_INIT_EMAIL,
                FAILURE_PASSWORD_RESET_INIT_EMAIL
            ],
            authenticated: false
        }
    };
}

/**
 *
 * @param {*} form the form data
 * @param {*} email the email user encoded in base64
 * @param {*} token the token to identify the resetpassword init encoded in base64
 */
export function passwordResetCommit(form, email, token) {
    // Remove password confirmation field
    _.unset(form, 'confirmation');

    // add url params to body
    let body = _.assign({}, form, { email: email, token: token });

    return {
        [CALL_API]: {
            endpoint: '/auth/password-reset',
            method: HTTP_METHOD_PUT,
            body: body,
            types: [
                REQUEST_PASSWORD_RESET_COMMIT,
                SUCCESS_PASSWORD_RESET_COMMIT,
                FAILURE_PASSWORD_RESET_COMMIT
            ],
            authenticated: false
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/actions.js